import { render, staticRenderFns } from "./AttachmentInput.vue?vue&type=template&id=4d078e7e&scoped=true&"
import script from "./AttachmentInput.vue?vue&type=script&lang=js&"
export * from "./AttachmentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d078e7e",
  null
  
)

export default component.exports